// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { SendResultFragment } from './send-result.fragment.generated';
export type SendAllResponseFragment = { __typename?: 'SendAllResponseDTO', results: Array<{ __typename?: 'SendResultDTO', error: string | null, invoiceId: number }> };

export const SendAllResponseFragment = gql`
    fragment SendAllResponse on SendAllResponseDTO {
  results {
    ...SendResult
  }
}
    ${SendResultFragment}`;
/* eslint-enable */